import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { PayoutForm } from '@/features/cleaner/payout-form';
import { HeaderDashboard } from '@/components/shared/header-dashboard';

export const Route = createFileRoute(
  '/(cleaner)/_authenticated/cleaner/payout-now'
)({
  component: PayoutNowPage,
});

function PayoutNowPage() {
  const navigate = useNavigate();
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.BackButton
          onClick={() => navigate({ to: '/cleaner/payout' })}
        />
        <HeaderDashboard.Title>Payout Now</HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-4">
        <PayoutForm />
      </div>
    </div>
  );
}
